import { gql, graphql } from "react-apollo"
import { GetAttractLoopsQuery } from "./withAttractLoops"

const MUTATE_DELETE_ATTRACT_LOOP = gql`
  mutation DeleteAttractLoop($id: ID!) {
    deleteAttractLoop(id: $id) {
      id
    }
  }
`

const mutateDeleteAttractLoop = graphql(MUTATE_DELETE_ATTRACT_LOOP, {
  name: "mutateDeleteAttractLoop",
  options: {
    refetchQueries: [{ query: GetAttractLoopsQuery, variables: { query: "" } }]
  },
  props: ({ mutateDeleteAttractLoop }) => ({
    deleteAttractLoop: (id: string) =>
      mutateDeleteAttractLoop({
        variables: { id }
      })
  })
})

export default mutateDeleteAttractLoop



// WEBPACK FOOTER //
// ./src/AttractLoops/queries/mutateDeleteAttractLoop.js